import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendExtractedBlogInstructions,
  BackendMutationExtractBlogInstructionsFromPdfArgs,
} from 'src/types/backend';

const MUTATION = gql`
  mutation ExtractBlogInstructionsFromPdf($sectionId: ID!, $documentId: ID!, $projectId: ID) {
    extractBlogInstructionsFromPdf(
      sectionId: $sectionId
      documentId: $documentId
      projectId: $projectId
    ) {
      instructions
      status
      extractionErrors
    }
  }
`;

type Variables = BackendMutationExtractBlogInstructionsFromPdfArgs;
type Result = Pick<
  BackendExtractedBlogInstructions,
  'instructions' | 'status' | 'extractionErrors'
>;

export const extractBlogInstructionsBasedOnPdf = async (variables: Variables) => {
  const result = await executeGqlMutation({
    mutation: MUTATION,
    variables,
    options: {
      traceAcRequests: true,
    },
  });

  return getSingleProp<Result>(result.data);
};
